(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plaizz-nutrition"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.PlaizzNutrition2) return;
  window.PlaizzNutrition2 = true;

  function select(tablist, tab) {
    tablist.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = !on;
        panel.classList.toggle('is-entering', on);
      }
    });
    var section = tablist.closest('[data-pzn]');
    if (section) {
      if (tab.dataset.p1) section.style.setProperty('--pzn-h', tab.dataset.p1); else section.style.removeProperty('--pzn-h');
      if (tab.dataset.sbg) section.style.setProperty('--pzn-sbg', tab.dataset.sbg); else section.style.removeProperty('--pzn-sbg');
    }
    try { tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-pzn-tabs] [role="tab"]');
    if (tab) select(tab.closest('[data-pzn-tabs]'), tab);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var tab = e.target.closest && e.target.closest('[data-pzn-tabs] [role="tab"]');
    if (!tab) return;
    var tablist = tab.closest('[data-pzn-tabs]');
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = tabs[(i + tabs.length) % tabs.length];
    select(tablist, next);
    next.focus();
    e.preventDefault();
  });

  document.addEventListener('shopify:block:select', function (e) {
    var tab = document.getElementById('pzn-tab-' + e.detail.blockId);
    if (tab) select(tab.closest('[data-pzn-tabs]'), tab);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plaizz-pack-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.PlaizzComposer) return;
  window.PlaizzComposer = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = window.routes || {};
  var cartUrl = routes.cart_url || '/cart';
  var cartAddUrl = routes.cart_add_url || '/cart/add';

  /* ---------- Utilitaires ---------- */
  function splitThousands(str, sep) { return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    var fmt = format || ('{' + '{amount_with_comma_separator}' + '} €');
    var parts = (cents / 100).toFixed(2).split('.');
    var noDec = String(Math.round(cents / 100));
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return splitThousands(parts[0], ',') + '.' + parts[1];
        case 'amount_no_decimals': return splitThousands(noDec, ',');
        case 'amount_no_decimals_with_comma_separator': return splitThousands(noDec, '.');
        case 'amount_with_space_separator': return splitThousands(parts[0], ' ') + ',' + parts[1];
        case 'amount_no_decimals_with_space_separator': return splitThousands(noDec, ' ');
        case 'amount_with_apostrophe_separator': return splitThousands(parts[0], "'") + '.' + parts[1];
        default: return splitThousands(parts[0], '.') + ',' + parts[1];
      }
    });
  }
  function plural(text, n) {
    return (text || '').replace(/\[n\]/g, n).replace(/\[sachets\]/g, n > 1 ? 'sachets' : 'sachet');
  }
  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
  function restart(el, cls) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }

  /* ---------- Panier ---------- */
  function getCartTarget() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
  function addToCart(items) {
    var target = getCartTarget();
    var body = { items: items };
    if (target && typeof target.getSectionsToRender === 'function') {
      body.sections = target.getSectionsToRender().map(function (x) { return x.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw new Error(data.description || data.message || "Impossible d'ajouter au panier.");
        return { data: data, target: target };
      });
    });
  }
  function afterAdd(root, result) {
    var mode = root.dataset.afterAdd || 'drawer';
    var data = result.data, target = result.target;
    if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'plaizz-composer', cartData: data }); } catch (e) {}
    }
    if (mode === 'cart') { window.location.href = cartUrl; return; }
    if (mode === 'drawer' && target && typeof target.renderContents === 'function' && data.sections) {
      var first = (data.items && data.items[0]) || {};
      if (target.classList.contains('is-empty')) target.classList.remove('is-empty');
      try { target.renderContents(Object.assign({}, first, { sections: data.sections })); } catch (e) {}
    }
  }

  /* ---------- Lecture du panier ---------- */
  function fetchCart() {
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function lowerFirst(s) { s = s || ''; return s.charAt(0).toLowerCase() + s.slice(1); }

  /* ---------- Promesse d'expédition ---------- */
  var DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  function nextBusinessDay(d) { var x = (d + 1) % 7; while (x === 0 || x === 6) x = (x + 1) % 7; return x; }
  function updatePromise(root) {
    var el = root.querySelector('[data-pzk-promise]');
    if (!el) return;
    var cutoff = parseInt(el.dataset.cutoff, 10) || 14;
    var parts;
    try { parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()); }
    catch (e) { return; }
    var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
    var day = WD[get('weekday')];
    var minutes = (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10);
    if (isNaN(day) || isNaN(minutes)) return;
    var label = function (t) { return t === (day + 1) % 7 ? 'demain' : DAYS[t]; };
    var text;
    if (day >= 1 && day <= 5 && minutes < cutoff * 60) {
      var left = cutoff * 60 - minutes, h = Math.floor(left / 60), m = left % 60;
      text = (el.dataset.before || '').replace('[temps]', (h > 0 ? h + ' h ' : '') + m + ' min').replace('[jour]', label(nextBusinessDay(day)));
    } else {
      text = (el.dataset.after || '').replace('[jour]', label(nextBusinessDay(day)));
    }
    el.querySelector('[data-pzk-promise-text]').textContent = text;
    el.hidden = false;
  }

  /* ---------- Composeur ---------- */
  function init(root) {
    if (root.dataset.pzkReady) return;
    root.dataset.pzkReady = '1';

    var minQty = parseInt(root.dataset.min, 10) || 1;
    var maxQty = parseInt(root.dataset.max, 10) || 99;
    var fmt = root.dataset.moneyFormat;
    var animate = !reduceMotion && !root.classList.contains('pzk--static');
    var slotsEl = root.querySelector('[data-pzk-slots]');
    var atc = root.querySelector('[data-pzk-atc]');
    var atcText = root.querySelector('[data-pzk-atc-text]');
    var sticky = root.querySelector('[data-pzk-sticky]');
    var stickyBtn = root.querySelector('[data-pzk-atc-sticky]');
    var stickyText = root.querySelector('[data-pzk-sticky-text]');
    var wasReady = false;

    var flavors = Array.prototype.map.call(root.querySelectorAll('[data-pzk-flavor]'), function (card) {
      var max = card.dataset.max === '' ? Infinity : parseInt(card.dataset.max, 10);
      return {
        card: card,
        id: parseInt(card.dataset.variant, 10),
        price: parseInt(card.dataset.price, 10) || 0,
        max: isNaN(max) ? Infinity : max,
        available: card.dataset.available === 'true',
        color: card.dataset.color, dark: card.dataset.dark, tint: card.dataset.tint,
        img: card.dataset.img,
        qty: 0,
        out: card.querySelector('[data-pzk-qty]'),
        dec: card.querySelector('[data-pzk-dec]'),
        inc: card.querySelector('[data-pzk-inc]')
      };
    });

    var milestones = Array.prototype.map.call(root.querySelectorAll('[data-pzk-ms]'), function (el) {
      return { el: el, kind: el.dataset.kind, qty: parseInt(el.dataset.qty, 10) || 0, pct: parseFloat(el.dataset.pct) || 0, label: el.dataset.label, reached: false };
    });
    var tiers = milestones.filter(function (m) { return m.kind === 'tier' && m.qty > 0; }).sort(function (a, b) { return a.qty - b.qty; });
    var shipMs = milestones.filter(function (m) { return m.kind === 'ship'; })[0] || null;
    var threshold = parseInt(root.dataset.threshold, 10) || 0;
    var stepsEl = root.querySelector('[data-pzk-steps]');
    var rfill = root.querySelector('[data-pzk-rfill]');
    var flavorIds = {};
    var cartBase = 0;   /* total du panier actuel (centimes) */
    var cartQty = 0;    /* sachets de ce module déjà dans le panier */

    function pctFor(n) { var p = 0; tiers.forEach(function (t) { if (n >= t.qty) p = t.pct; }); return p; }

    function syncCart() {
      return fetchCart().then(function (cart) {
        cartBase = cart.total_price || 0;
        cartQty = (cart.items || []).reduce(function (n, it) { return flavorIds[it.variant_id] ? n + it.quantity : n; }, 0);
        update();
      }).catch(function () {});
    }

    function total() { return flavors.reduce(function (n, f) { return n + f.qty; }, 0); }
    function sequence() {
      var seq = [];
      flavors.forEach(function (f, i) { for (var k = 0; k < f.qty; k++) seq.push(i); });
      return seq;
    }

    function fillSlot(slot, fi) {
      slot._fi = fi;
      slot.innerHTML = '';
      if (fi < 0) {
        slot.className = 'pzk-slot';
        slot.removeAttribute('style');
        return;
      }
      var f = flavors[fi];
      slot.className = 'pzk-slot is-filled';
      slot.style.setProperty('--f', f.color);
      slot.style.setProperty('--f-tint', f.tint);
      if (f.img) {
        var img = document.createElement('img');
        img.src = f.img; img.alt = ''; img.loading = 'lazy';
        slot.appendChild(img);
      } else {
        var bag = document.createElement('span');
        bag.className = 'pzk-slot__bag';
        slot.appendChild(bag);
      }
    }

    function renderSlots(changed, mode) {
      if (!slotsEl) return null;
      var seq = sequence();
      var n = Math.max(minQty, seq.length);
      n = Math.ceil(n / 6) * 6;
      while (slotsEl.children.length < n) { var sp = document.createElement('span'); sp.className = 'pzk-slot'; slotsEl.appendChild(sp); }
      while (slotsEl.children.length > n) slotsEl.removeChild(slotsEl.lastChild);
      for (var p = 0; p < n; p++) {
        var slot = slotsEl.children[p];
        var fi = p < seq.length ? seq[p] : -1;
        if (slot._fi !== fi || mode === 'all') fillSlot(slot, fi);
        slot.style.animationDelay = '';
        if (mode === 'all' && fi >= 0 && animate) {
          slot.style.animationDelay = (p * 45) + 'ms';
          restart(slot, 'is-new');
        }
      }
      if (mode === 'inc') {
        var pos = seq.lastIndexOf(changed);
        return pos >= 0 ? slotsEl.children[pos] : null;
      }
      return null;
    }

    function inView(rect) { return rect.bottom > 0 && rect.top < window.innerHeight && rect.width > 0; }

    function fly(f, slot) {
      if (!animate || !slot || !slot.animate) return false;
      var src = f.card.querySelector('.pzk-flavor__img');
      if (!src) return false;
      var a = src.getBoundingClientRect(), b = slot.getBoundingClientRect();
      if (!inView(a) || !inView(b)) return false;
      var el = document.createElement('span');
      el.className = 'pzk-flyer';
      el.style.left = a.left + 'px'; el.style.top = a.top + 'px';
      el.style.width = a.width + 'px'; el.style.height = a.height + 'px';
      el.style.setProperty('--f', f.color);
      if (f.img) { var img = document.createElement('img'); img.src = f.img; img.alt = ''; el.appendChild(img); }
      else { var bag = document.createElement('span'); bag.className = 'pzk-slot__bag'; el.appendChild(bag); }
      document.body.appendChild(el);
      var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
      var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      var sc = Math.max(.3, Math.min(1, b.width / a.width));
      slot.classList.add('is-incoming');
      var anim = el.animate([
        { transform: 'translate(0,0) scale(1) rotate(0)' },
        { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 - 90) + 'px) scale(' + (sc + .2) + ') rotate(-12deg)', offset: .5 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ') rotate(0)' }
      ], { duration: 620, easing: 'cubic-bezier(.45,0,.25,1)' });
      anim.onfinish = function () {
        el.remove();
        slot.classList.remove('is-incoming');
        restart(slot, 'is-new');
      };
      return true;
    }

    function update() {
      var tot = total();
      var ready = tot >= minQty;
      root.classList.toggle('is-ready', ready);
      if (ready && !wasReady && animate) restart(root, 'is-ready');
      wasReady = ready;

      each(root, '[data-pzk-count]', function (el) { el.textContent = tot; });
      each(root, '[data-pzk-word]', function (el) { el.textContent = tot > 1 ? 'sachets' : 'sachet'; });
      each(root, '[data-pzk-fill]', function (el) { el.style.transform = 'scaleX(' + Math.min(1, tot / minQty) + ')'; });

      /* Prix (les sachets déjà dans le panier comptent pour les paliers, comme au paiement) */
      var eff = tot + cartQty;
      var sub = flavors.reduce(function (n, f) { return n + f.qty * f.price; }, 0);
      var pct = pctFor(eff);
      var disc = Math.round(sub * pct / 100);
      var fin = sub - disc;
      updateRewards(tot, eff, sub, fin);
      each(root, '[data-pzk-total]', function (el) { el.textContent = formatMoney(fin, fmt); });
      var strike = root.querySelector('[data-pzk-strike]');
      if (strike) { strike.hidden = !disc; strike.textContent = disc ? formatMoney(sub, fmt) : ''; }
      var unit = root.querySelector('[data-pzk-unit]');
      if (unit) unit.textContent = tot > 0 ? 'Soit ' + formatMoney(Math.round(fin / tot), fmt) + ' le sachet' : '';


      /* Boutons */
      flavors.forEach(function (f) {
        if (f.out) f.out.textContent = f.qty;
        f.card.classList.toggle('is-active', f.qty > 0);
        if (f.dec) f.dec.disabled = f.qty <= 0;
        if (f.inc) f.inc.disabled = !f.available || f.qty >= f.max || tot >= maxQty;
      });
      if (atc) {
        atc.disabled = !ready;
        atcText.textContent = ready ? (root.dataset.atcLabel + ' · ' + formatMoney(fin, fmt)) : plural(root.dataset.atcMissing, minQty - tot);
      }
      if (stickyBtn) {
        stickyBtn.disabled = !ready;
        stickyText.textContent = ready ? 'Ajouter' : plural('Encore [n]', minQty - tot);
      }
    }

    /* Barre de récompenses : chaque étape est placée dans l'ordre où elle sera atteinte */
    function updateRewards(tot, eff, sub, fin) {
      var progress = root.querySelector('[data-pzk-progress]');
      var avg = tot > 0 ? sub / tot : flavors.reduce(function (m, f) { return f.available && f.price > 0 ? Math.min(m, f.price) : m; }, Infinity);
      if (!isFinite(avg)) avg = 0;

      if (shipMs) {
        shipMs.qty = null;
        if (threshold > 0 && avg > 0) {
          if (cartBase >= threshold) { shipMs.qty = cartQty; }
          else {
            for (var k = 1; k <= maxQty; k++) {
              var price = Math.round(k * avg * (1 - pctFor(cartQty + k) / 100));
              if (cartBase + price >= threshold) { shipMs.qty = cartQty + k; break; }
            }
          }
        }
        shipMs.el.hidden = shipMs.qty === null;
        if (shipMs.qty !== null) shipMs.reached = cartBase + fin >= threshold;
      }

      var list = milestones.filter(function (m) { return m.kind !== 'ship' || m.qty !== null; });
      list.forEach(function (m) { if (m.kind === 'tier') m.reached = eff >= m.qty; });
      list.sort(function (a, b) { return a.qty - b.qty || (a.kind === 'ship' ? -1 : 1); });

      var n = list.length;
      if (stepsEl) stepsEl.style.setProperty('--pz-n', n);
      var next = null;
      list.forEach(function (m, idx) {
        m.el.style.order = idx;
        var was = m.el.classList.contains('is-reached');
        m.el.classList.toggle('is-reached', m.reached);
        if (m.reached && !was && animate) restart(m.el, 'is-pop');
        if (!m.reached && !next) next = m;
        m.el.classList.toggle('is-next', m === next);
      });

      /* Remplissage par segments : chaque étape est au centre de sa colonne */
      if (rfill && n) {
        var pos = 0, prevQty = 0, prevPos = 0;
        for (var i = 0; i < n; i++) {
          var at = (i + .5) / n * 100;
          var m = list[i];
          if (m.reached) { pos = at; prevQty = m.qty; prevPos = at; continue; }
          var span = Math.max(1, m.qty - prevQty);
          pos = prevPos + (at - prevPos) * Math.max(0, Math.min(1, (eff - prevQty) / span));
          break;
        }
        if (list.every(function (m) { return m.reached; })) pos = 100;
        rfill.style.width = pos + '%';
      }

      if (progress) {
        var html;
        if (tot < minQty) html = plural(root.dataset.textMissing, minQty - tot);
        else if (next) html = plural(root.dataset.textNext, Math.max(1, next.qty - eff)).replace('[recompense]', (next.kind === 'ship' ? 'la ' : '') + lowerFirst(next.label));
        else html = root.dataset.textAll || '';
        progress.textContent = html;
      }
    }

    function change(i, delta) {
      var f = flavors[i];
      if (!f) return;
      var tot = total();
      if (delta > 0 && (!f.available || f.qty >= f.max || tot >= maxQty)) return;
      if (delta < 0 && f.qty <= 0) return;
      f.qty += delta;
      if (delta > 0 && animate) {
        Array.prototype.forEach.call(root.querySelectorAll('.pzk-floater[data-flavor="' + i + '"]'), function (fl) { restart(fl, 'is-bump'); });
      }
      if (f.out && animate) restart(f.out, 'is-bump');
      if (delta > 0 && animate) restart(f.card, 'is-bump');
      var slot = renderSlots(i, delta > 0 ? 'inc' : 'dec');
      if (delta > 0 && !fly(f, slot)) {
        if (slot && animate) restart(slot, 'is-new');
        var sc = sticky && sticky.querySelector('.pzk-sticky__count');
        if (sc && animate) restart(sc, 'is-bump');
      }
      update();
    }

    function preset(kind) {
      var avail = flavors.filter(function (f) { return f.available && f.max > 0; });
      flavors.forEach(function (f) { f.qty = 0; });
      if (kind !== 'clear' && avail.length) {
        var target = Math.min(maxQty, Math.max(minQty, total()));
        if (kind === 'equal') {
          var per = Math.ceil(target / avail.length);
          var left = Math.min(maxQty, per * avail.length);
          avail.forEach(function (f) { var q = Math.min(per, f.max, left); f.qty = q; left -= q; });
        } else {
          for (var k = 0; k < target; k++) {
            var pool = avail.filter(function (f) { return f.qty < f.max; });
            if (!pool.length) break;
            pool[Math.floor(Math.random() * pool.length)].qty++;
          }
        }
      }
      renderSlots(-1, 'all');
      update();
    }

    root.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-pzk-inc]');
      if (inc && root.contains(inc)) { change(parseInt(inc.dataset.pzkInc, 10), 1); return; }
      var dec = e.target.closest('[data-pzk-dec]');
      if (dec && root.contains(dec)) { change(parseInt(dec.dataset.pzkDec, 10), -1); return; }
      var pre = e.target.closest('[data-pzk-preset]');
      if (pre && root.contains(pre)) { preset(pre.dataset.pzkPreset); }
    });

    /* ---------- Carrousel photos (téléphone) ---------- */
    var gtrack = root.querySelector('[data-pzk-gtrack]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pzk-dot]'));
    if (gtrack && dots.length) {
      var photos = Array.prototype.slice.call(gtrack.children);
      var setDot = function () {
        var best = 0, bestD = Infinity, left = gtrack.getBoundingClientRect().left;
        photos.forEach(function (ph, k) { var d = Math.abs(ph.getBoundingClientRect().left - left - 16); if (d < bestD) { bestD = d; best = k; } });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === best ? 'true' : 'false'); });
      };
      var raf = null;
      gtrack.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; setDot(); }); }, { passive: true });
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () {
          var ph = photos[k]; if (!ph) return;
          gtrack.scrollTo({ left: ph.offsetLeft - photos[0].offsetLeft, behavior: animate ? 'smooth' : 'auto' });
        });
      });
      document.addEventListener('shopify:block:select', function (e) {
        var ph = e.target && e.target.closest && e.target.closest('[data-pzk-photo]');
        if (ph && gtrack.contains(ph)) gtrack.scrollTo({ left: ph.offsetLeft - photos[0].offsetLeft });
      });
    }

    /* Ajout au panier */
    function submit() {
      var tot = total();
      if (tot < minQty || atc.getAttribute('aria-busy') === 'true') return;
      var items = flavors.filter(function (f) { return f.qty > 0; }).map(function (f) {
        return { id: f.id, quantity: f.qty, properties: { _pack: root.dataset.packLabel || 'Pack composé' } };
      });
      var err = root.querySelector('[data-pzk-error]');
      if (err) err.hidden = true;
      atc.setAttribute('aria-busy', 'true');
      if (stickyBtn) stickyBtn.disabled = true;
      var burstWrap = root.querySelector('[data-pzk-burst]');
      if (burstWrap && animate) {
        restart(burstWrap, 'is-bursting');
        setTimeout(function () { burstWrap.classList.remove('is-bursting'); }, 1100);
      }
      addToCart(items)
        .then(function (result) {
          var msg = root.querySelector('[data-pzk-added]');
          if (msg) { msg.hidden = false; clearTimeout(msg._t); msg._t = setTimeout(function () { msg.hidden = true; }, 3500); }
          afterAdd(root, result);
          syncCart();
          if (root.dataset.reset === 'true') { flavors.forEach(function (f) { f.qty = 0; }); renderSlots(-1, 'all'); }
        })
        .catch(function (error) {
          if (err) { err.textContent = error.message; err.hidden = false; }
        })
        .finally(function () { atc.removeAttribute('aria-busy'); update(); });
    }
    if (atc) atc.addEventListener('click', submit);
    if (stickyBtn) stickyBtn.addEventListener('click', submit);

    /* Barre collante : visible quand la section est à l'écran mais pas le bouton principal */
    if (sticky && atc && 'IntersectionObserver' in window) {
      var secIn = false, atcIn = false;
      var sync = function () {
        var show = secIn && !atcIn;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (en) { secIn = en[0].isIntersecting; sync(); }, { rootMargin: '0px 0px -120px 0px' }).observe(root.querySelector('.pzk-grid') || root);
      new IntersectionObserver(function (en) { atcIn = en[0].isIntersecting; sync(); }).observe(atc);
    }

    if (root.dataset.startFilled === 'true') preset('equal');
    else { renderSlots(-1, 'dec'); update(); }

    flavors.forEach(function (f) { flavorIds[f.id] = true; });
    syncCart();
    document.addEventListener('cart:updated', syncCart);
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (ev) { if (!ev || ev.source !== 'plaizz-composer') syncCart(); }); } catch (e) {}
    }
    updatePromise(root);
    setInterval(function () { updatePromise(root); }, 60000);
  }

  function initAll(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-pzk]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plaizz-pack-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.PlaizzHero) return;
  window.PlaizzHero = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = window.routes || {};
  var cartUrl = routes.cart_url || '/cart';
  var cartAddUrl = routes.cart_add_url || '/cart/add';

  function splitThousands(str, sep) { return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    var fmt = format || ('{' + '{amount_with_comma_separator}' + '} €');
    var parts = (cents / 100).toFixed(2).split('.');
    var noDec = String(Math.round(cents / 100));
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return splitThousands(parts[0], ',') + '.' + parts[1];
        case 'amount_no_decimals': return splitThousands(noDec, ',');
        case 'amount_no_decimals_with_comma_separator': return splitThousands(noDec, '.');
        case 'amount_with_space_separator': return splitThousands(parts[0], ' ') + ',' + parts[1];
        case 'amount_no_decimals_with_space_separator': return splitThousands(noDec, ' ');
        case 'amount_with_apostrophe_separator': return splitThousands(parts[0], "'") + '.' + parts[1];
        default: return splitThousands(parts[0], '.') + ',' + parts[1];
      }
    });
  }

  function getCartTarget() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }

  function addToCart(items) {
    var target = getCartTarget();
    var body = { items: items };
    if (target && typeof target.getSectionsToRender === 'function') {
      body.sections = target.getSectionsToRender().map(function (x) { return x.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw new Error(data.description || data.message || "Impossible d'ajouter au panier.");
        return { data: data, target: target };
      });
    });
  }

  function afterAdd(root, result, variantId) {
    var mode = root.dataset.afterAdd || 'drawer';
    var data = result.data, target = result.target;
    if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'plaizz-hero', productVariantId: variantId, cartData: data }); } catch (e) {}
    }
    if (mode === 'cart') { window.location.href = cartUrl; return; }
    if (mode === 'drawer' && target && typeof target.renderContents === 'function' && data.sections) {
      var first = (data.items && data.items[0]) || {};
      if (target.classList.contains('is-empty')) target.classList.remove('is-empty');
      try { target.renderContents(Object.assign({}, first, { sections: data.sections })); } catch (e) {}
    }
  }

  function refreshShipping(root) {
    var bar = root.querySelector('[data-pzh-ship]');
    if (!bar) return;
    var threshold = parseInt(root.dataset.threshold, 10) || 0;
    if (!threshold) { bar.hidden = true; return; }
    fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price || 0;
        var remaining = threshold - total;
        var text = bar.querySelector('[data-pzh-ship-text]');
        var fill = bar.querySelector('[data-pzh-ship-fill]');
        var upsell = bar.querySelector('[data-pzh-upsell]');
        if (text) {
          if (total === 0) text.textContent = bar.dataset.textEmpty;
          else if (remaining > 0) text.textContent = (bar.dataset.textProgress || '').replace('[reste]', formatMoney(remaining, root.dataset.moneyFormat));
          else text.textContent = bar.dataset.textDone;
        }
        if (fill) fill.style.transform = 'scaleX(' + Math.min(1, total / threshold) + ')';
        bar.classList.toggle('is-done', remaining <= 0);
        if (upsell) {
          var up = parseInt(root.dataset.upsellPrice, 10) || 0;
          upsell.hidden = !(total > 0 && remaining > 0 && remaining <= up);
        }
      })
      .catch(function () {});
  }

  var DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  function nextBusinessDay(d) { var x = (d + 1) % 7; while (x === 0 || x === 6) x = (x + 1) % 7; return x; }
  function updatePromise(root) {
    var el = root.querySelector('[data-pzh-promise]');
    if (!el) return;
    var cutoff = parseInt(el.dataset.cutoff, 10) || 14;
    var parts;
    try { parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()); }
    catch (e) { return; }
    var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
    var day = WD[get('weekday')];
    var hour = parseInt(get('hour'), 10) % 24;
    var minutes = hour * 60 + parseInt(get('minute'), 10);
    if (isNaN(day) || isNaN(minutes)) return;
    var label = function (t) { return t === (day + 1) % 7 ? 'demain' : DAYS[t]; };
    var text;
    if (day >= 1 && day <= 5 && minutes < cutoff * 60) {
      var left = cutoff * 60 - minutes, h = Math.floor(left / 60), m = left % 60;
      text = (el.dataset.before || '').replace('[temps]', (h > 0 ? h + ' h ' : '') + m + ' min').replace('[jour]', label(nextBusinessDay(day)));
    } else {
      text = (el.dataset.after || '').replace('[jour]', label(nextBusinessDay(day)));
    }
    el.querySelector('[data-pzh-promise-text]').textContent = text;
    el.hidden = false;
  }

  function burst(root) {
    if (reduceMotion || root.classList.contains('pzh--static')) return;
    var wrap = root.querySelector('[data-pzh-burst]');
    if (!wrap) return;
    wrap.classList.remove('is-bursting'); void wrap.offsetWidth; wrap.classList.add('is-bursting');
    clearTimeout(wrap._t); wrap._t = setTimeout(function () { wrap.classList.remove('is-bursting'); }, 1100);
  }
  function flash(root, sel, text) {
    var el = root.querySelector(sel);
    if (!el) return;
    if (text) el.textContent = text;
    el.hidden = false;
    clearTimeout(el._t); el._t = setTimeout(function () { el.hidden = true; }, 3000);
  }

  function init(root) {
    if (root.dataset.pzhReady) return;
    root.dataset.pzhReady = '1';

    var thumbs = root.querySelectorAll('[data-pzh-thumb]');
    var slides = root.querySelectorAll('[data-pzh-slide]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.dataset.pzhThumb;
        slides.forEach(function (sl) { var on = sl.dataset.pzhSlide === idx; sl.hidden = !on; sl.classList.toggle('is-entering', on); });
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === btn ? 'true' : 'false'); });
      });
    });

    var input = root.querySelector('[data-pzh-qty-input]');
    var atc = root.querySelector('[data-pzh-atc]');
    var totalEl = root.querySelector('[data-pzh-atc-total]');
    var unit = atc ? parseInt(atc.dataset.unitPrice, 10) || 0 : 0;
    function clampQty() {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > 10) v = 10;
      input.value = v;
      if (totalEl) totalEl.textContent = formatMoney(unit * v, root.dataset.moneyFormat);
      return v;
    }
    if (input) {
      root.querySelectorAll('[data-pzh-qty]').forEach(function (b) {
        b.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.pzhQty, 10); clampQty(); });
      });
      input.addEventListener('change', clampQty);
    }

    var form = root.querySelector('[data-pzh-form]');
    if (form && atc) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc.disabled || atc.getAttribute('aria-busy') === 'true') return;
        var vid = parseInt(form.querySelector('[name="id"]').value, 10);
        var qty = input ? clampQty() : 1;
        atc.setAttribute('aria-busy', 'true');
        burst(root);
        addToCart([{ id: vid, quantity: qty }])
          .then(function (r) { flash(root, '[data-pzh-added]'); afterAdd(root, r, vid); refreshShipping(root); })
          .catch(function (err) { flash(root, '[data-pzh-error]', err.message); })
          .finally(function () { atc.removeAttribute('aria-busy'); });
      });
    }

    var upsell = root.querySelector('[data-pzh-upsell]');
    if (upsell && root.dataset.upsellVariant) {
      upsell.addEventListener('click', function () {
        var vid = parseInt(root.dataset.upsellVariant, 10);
        upsell.disabled = true;
        burst(root);
        addToCart([{ id: vid, quantity: 1 }])
          .then(function (r) { flash(root, '[data-pzh-added]'); afterAdd(root, r, vid); refreshShipping(root); })
          .catch(function (err) { flash(root, '[data-pzh-error]', err.message); })
          .finally(function () { upsell.disabled = false; });
      });
    }

    var sticky = root.querySelector('[data-pzh-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var sb = sticky.querySelector('button');
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (sb) sb.tabIndex = show ? 0 : -1;
      }).observe(atc);
    }

    refreshShipping(root);
    document.addEventListener('cart:updated', function () { refreshShipping(root); });
    updatePromise(root);
    setInterval(function () { updatePromise(root); }, 60000);
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-pzh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
